<template>
    <div class="home">
      <div class="container">
        <div class="columns is-centered">
          <div class="column">
            <ValidationObserver v-slot="{ errors }" tag="div">
            <input-form
              ref="form"
              :errors="errors"
              name="ProjectSummaryForm"
              @submit.prevent="onFileUpload"
            >
            <div class="content">
                <h1>Project Summary Form</h1>
                <callout type="warning">
                  Please <b>do not start filling out the form unless you have all the required information ready.</b> The form requires details from the <b>Project Summary Form</b>, and you will need this information in front of you to complete your submission correctly.
                  If you exit or clear your browser midway, your data will not be saved. To avoid delays, <b>make sure you have Project Summary Form fully prepared before you start.</b>
                </callout>
                <h2>Developer Information</h2>
                <div class="columns">
                    <div class="column">
                        <vee-textbox
                          v-model="Organization"
                          error="This field is required"
                          name="input-project-organization"
                          required
                          rules="required"
                          placeholder="Organization"
                          type="text"
                          />
                    </div>
                </div>
                <h3>Address</h3>
                <div class="columns">
                    <div class="column">
                        <vee-textbox
                          v-model="Address.Street1"
                          error="This field is required"
                          name="input-project-street1"
                          required
                          rules="required"
                          placeholder="Street Address"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="Address.Street2"
                          error="This field is required"
                          name="input-project-street2"
                          placeholder="Apt / Unit"
                          type="text"
                          />
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <vee-textbox
                          v-model="Address.Zip"
                          error="This field is required"
                          name="input-project-zip"
                          required
                          rules="required"
                          placeholder="Zip"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="Address.City"
                          error="This field is required"
                          name="input-project-city"
                          required
                          rules="required"
                          placeholder="City"
                          type="text"
                          />
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <vee-dropdown
                          v-model="Address.State"
                          :options="States"
                          error="This field is required"
                          name="input-project-state"
                          required
                          rules="required"
                          placeholder="State"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="Address.Country"
                          error="This field is required"
                          name="input-project-country"
                          required
                          rules="required"
                          readonly
                          placeholder="Country"
                          type="text"
                          />
                    </div>
                </div>
                <h3>Contacts</h3>
                <div class="columns">
                    <div class="column">
                        <vee-textbox
                          v-model="Contact.Name"
                          error="This field is required"
                          name="input-contact-name"
                          required
                          rules="required"
                          placeholder="Name"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="Contact.Phone"
                          error="This field is required"
                          name="input-contact-phone"
                          required
                          rules="required|phone"
                          placeholder="Phone"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="Contact.Email"
                          error="This field is required"
                          name="input-contact-email"
                          required
                          rules="required|email"
                          placeholder="Email"
                          type="text"
                          />
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <vee-textbox
                          v-model="SecondContact.Name"
                          error="This field is required"
                          name="input-contact-name"
                          required
                          rules="required"
                          placeholder="Name"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="SecondContact.Phone"
                          error="This field is required"
                          name="input-contact-phone"
                          required
                          rules="required|phone"
                          placeholder="Phone"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="SecondContact.Email"
                          error="This field is required"
                          name="input-contact-email"
                          required
                          rules="required|email"
                          placeholder="Email"
                          type="text"
                          />
                    </div>
                </div>
                <h3>Developer Details</h3>
                <div>
                    <div class="column">
                        <vee-dropdown
                          v-model="EntityType"
                          error="This field is required"
                          name="input-entity-type"
                          :options="entityTypes"
                          required
                          rules="required"
                          placeholder="Entity Type"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textarea
                          v-model="DeveloperDescription"
                          error="This field is required"
                          name="input-developer-description"
                          required
                          rules="required"
                          placeholder="Developer Description"
                          type="text"
                          />
                    </div>
                </div>
            </div>
            <div class="column is-2 is-offset-10" style="text-align: right;">
                <button
                type="button"
                class="button is-primary"
                @click="nextPage"
                >
                Next
                </button>
            </div>
            </input-form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
// import { getPropertyValueOrDefault } from "@/utilities/functions.js";
// import buildPropertyInfoObject from "@/utilities/get-property-info-object.js";
// import axios from "axios";
import options from "@/utilities/options";

export default {
  name: 'ProjectSummaryForm',
  mixins: [options],
  data() {
    return {
      Organization: null,
      Address: { Street1: null, Street2: null, City: null, State: null, Zip: null, Country: "United States" },
      Contact: { Name: null, Email: null, Phone: null },
      SecondContact: { Name: null, Email: null, Phone: null },
      EntityType: null,
      DeveloperDescription: null,
      ProjectName: null,
      ProposalType: null,
      NumberOfUnits: null,
      FundingRequested: null,
      TotalDevelopmentCost: null,
      TotalConstructionCost: null,
      SquareFootage: null,
      DevelopmentCostPerSquareFoot: null,
      ConstructionCostPerSquareFoot: null,
      SubsidyPerUnit: null,
      DevelopmentCategory: null,
      DevelopmentCategory2: null,
      ExpirationYear: null,
      PopulationServed: [],
      PopulationServedDescription: null,
      ServicesOffered: null,
      ServicesOfferedDescription: null,
      MixedUse: null,
      CommercialTenant: null,
      MixedIncomeHousingBonus: null,
      Attributes: [],
      StrategyArea: [],
      ProjectDescription: null,
      AdditionalFeatures: null,
      Borrower: {Role: "Borrower", CompanyName: null, StateOfEntity: null, Address: { Street1: null, Street2: null, City: null, State: null, Zip: null, Country: "United States" }, Contact: { Name: null, Email: null, Phone: null }},
      GeneralPartnerOrManagingMember: null,
      GeneralPartner: {Role: null, CompanyName: null, StateOfEntity: null, Address: { Street1: null, Street2: null, City: null, State: null, Zip: null, Country: "United States" }, Contact: { Name: null, Email: null, Phone: null }},
      OptionalContacts: [],
      Architect: {Role: "Architect", CompanyName: null, Address: { Street1: null, Street2: null, City: null, State: null, Zip: null, Country: "United States" }, Contact: { Name: null, Email: null, Phone: null }},
      Attorney: {Role: "Attorney", CompanyName: null, Address: { Street1: null, Street2: null, City: null, State: null, Zip: null, Country: "United States" }, Contact: { Name: null, Email: null, Phone: null }},
      PropertyManagementCompany: {Role: "Management Agent", CompanyName: null, Address: { Street1: null, Street2: null, City: null, State: null, Zip: null, Country: "United States" }, Contact: { Name: null, Email: null, Phone: null }},
      Consultant: {Role: "Consultant", CompanyName: null, Address: { Street1: null, Street2: null, City: null, State: null, Zip: null, Country: "United States" }, Contact: { Name: null, Email: null, Phone: null }},
      Sites: [],
      NumberOfEfficiencyUnits: null,
      NumberOfOneBedroomUnits: null,
      NumberOfTwoBedroomUnits: null,
      NumberOfThreeBedroomUnits: null,
      NumberOfFourBedroomUnits: null,
      TotalUnits: null,
      AMI0to20: null,
      AMI20to30: null,
      AMI30to50: null,
      AMI50to60: null,
      AMI60to80: null,
      AMI80to120: null,
      AMI120Plus: null,
      AMITotal: null,
      Mobility: null,
      Sensory: null,
      Visitable: null,
      Clearinghouse: null,
      SiteControl: null,
      ZoningSecured: null,
      CommunityMeeting: null,
      EstimatedConstructionTimeline: null,
      ProjectWorkbook: [],
      ProposalDocuments: [],
      //EOPForm: [],
    };
  },
  async created(){
    window.scrollTo(0, 0);
    if(await this.$vlf.getItem('fullSummaryApplication') != null){
        Object.assign(this.$data, await this.$vlf.getItem('fullSummaryApplication'));
    }
  },
  methods: {
    async nextPage(){
        const isInputValid = await this.$refs.form.$parent.validate();
        if (isInputValid) {
            await this.$vlf.setItem('fullSummaryApplication', this.$data);
            
            this.$router.push({
                name: "RFPProjectInformation",
            });
        }
    },
  }
};
</script>